// extracted by css-extract-rspack-plugin
export default {"cls1":"PremiumBadge-cls1_Rb6","cls2":"PremiumBadge-cls2_Wt0 PremiumBadge-cls1_Rb6"};